module.exports = __webpack_public_path__ + "img/product.cfe02e6b.svg";